'use strict';

var resolveVariants = require('./resolve-variants.cjs');

function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariants.resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

exports.resolveVariant = resolveVariant;
//# sourceMappingURL=resolve-dynamic-variants.cjs.map
